export default __webpack_public_path__ + "static/media/sass-1.8aa78a83.svg";